import styled from 'styled-components'

export const ByText = styled.span`
    font-weight: 600;
    font-size: 14px;
    letter-spacing: 0.28px;
`
